import ColorfulLoading from './colorful-loading';
export default ColorfulLoading;
